import {
  type FieldActionsContextValue,
  useFieldActions,
} from '../../contexts/field-actions-context';
import { type WixFile } from '../form/types';
import { type IUploadFileFieldAction } from '../../services/upload-file';
import { type FileUploadFile } from 'wix-ui-tpa/cssVars';

export const useUploadFile = (uploadTarget: string) => {
  const { actions, formId } =
    useFieldActions() as FieldActionsContextValue<IUploadFileFieldAction>;

  return async (
    filesToUpload: FileUploadFile[],
    onDone: ({
      file,
      uploadedFile,
    }: {
      file: File;
      uploadedFile: WixFile;
    }) => void,
    onError: (error: unknown, file: File) => void,
  ): Promise<WixFile[]> => {
    if (!actions?.uploadFile || !filesToUpload.length) {
      if (!actions?.uploadFile) {
        console.error('No uploadFile action');
      }
      if (!filesToUpload.length) {
        console.error('No files to upload');
      }
      return [];
    }
    const uploadTasks = filesToUpload.map(({ file }) => {
      return actions
        .uploadFile({
          file,
          formId,
          uploadTarget,
        })
        .then((fileDescriptor) => {
          const { id, displayName, url, isPrivate } = fileDescriptor!;
          const uploadedFile = {
            fileId: id,
            displayName: displayName || file.name,
            url: !isPrivate ? url : undefined,
            fileType: file.type,
          } as WixFile;
          onDone({ file, uploadedFile });
          return uploadedFile;
        })
        .catch((_e) => {
          onError(_e, file);
        });
    });

    const uploadedValues = await Promise.all(uploadTasks);
    return uploadedValues.filter((v) => v !== undefined) as WixFile[];
  };
};
